<template>
  <div id="signin">
    <transition name="fade">
      <comp-message
        v-if="showMessage"
        :msgText="messageText"
        :msgSuccess="!messageIsErr"
        :msgError="messageIsErr"
        @closeMsg="showMessage = false"
      />
    </transition>

    <div class="container">
      <div class="logo"></div>
      <div class="form-group">
        <div class="form-container" :class="{ 'has-error': idHasError }">
          <label class="label" for="email">{{ idMessage }}</label>
          <input
            type="email"
            name=""
            id="email"
            placeholder="Type your email address"
            v-model.trim="userID"
            autofocus
          />
        </div>
        <div class="form-container" :class="{ 'has-error': pwHasError }">
          <label class="label" for="passward">{{ pwMessage }}</label>
          <input
            type="password"
            name=""
            id="password"
            placeholder="Type password"
            v-model.trim="userPW"
            @keyup.enter="onSignInClick"
          />
        </div>
      </div>
      <div class="button-group">
        <div class="button" @click="onSignInClick">Sign In</div>
        <div class="button-sub reset-password" @click="onResetPWClick">
          <span>Forgot Password?</span>
        </div>
        <div class="button-sub create-acc" @click="onSignUpClick">
          <span>Create Account</span>
        </div>
      </div>
      <div class="social-group">
        <div class="social apple" @click="performAppleLogin">
          Sign in with Apple ID
        </div>
        <div class="social facebook" @click="facebookCheckLoginStatus">
          Sign in with Facebook
        </div>
        <div class="social google" @click="performGoogleLogin">
          Sign in with Google
        </div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
/* global AppleID */
/* global FB */
/* global gapi */

import common from '@/utils/common'
import CompMessage from '@/components/CompMessage'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'Signin',
  mixins: [common],
  components: {
    CompMessage,
    CompLoading
  },
  data() {
    return {
      pageTitle: 'Sign In',

      showMessage: false,
      messageText: '',
      messageIsErr: false,

      isLoading: false,

      idHasError: false,
      pwHasError: false,

      idMessage: 'Email',
      pwMessage: 'Password',

      userID: '',
      userPW: '',

      auth2: null,
      googleLogin: false
    }
  },
  created() {
    localStorage.removeItem('tempID')
    localStorage.removeItem('tempPW')
    localStorage.removeItem('tempTermsAgree')

    gapi.load('auth2', () => {
      this.auth2 = gapi.auth2.init({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        cookiepolicy: 'single_host_origin'
      })

      // this.auth2.isSignedIn.listen(isSignedIn => {
      //   if (isSignedIn) {
      //   }
      // })

      this.auth2.currentUser.listen(() => {
        if (this.googleLogin) {
          this.googleCheckLoginStatus()
        }
      })

      // if (this.auth2.isSignedIn.get() === true) {
      //   this.auth2.signIn()
      // }
    })

    this.$parent.setNav(false)
    this.$parent.setHeader(this.pageTitle)
    this.$parent.setBottomTab(false)

    if (this.$route.params.signUpSocial) {
      const socialType = this.$route.params.signUpSocial
      switch (socialType) {
        case 'Apple':
          this.performAppleLogin()
          break
        case 'Facebook':
          this.facebookCheckLoginStatus()
          break
        case 'Google':
          this.performGoogleLogin()
          break
      }
    } else if (this.$route.params.socialType) {
      const socialType = this.$route.params.socialType
      switch (socialType) {
        case 'Apple':
          this.appleLoginDone(this.$route.params.userID)
          break
        case 'Facebook':
          this.performFacebookLogin()
          break
        case 'Google':
          this.googleCheckLoginStatus()
          break
      }
    } else if (this.$route.params.signUp) {
      this.showInfoMessage(
        'You are almost ready! Please check your mailbox to verify your email address.',
        false
      )
    } else if (this.$route.query) {
      const appleQuery = this.$route.query
      if (appleQuery.user) {
        const user = JSON.parse(appleQuery.user)
        this.appleLoginDone(user.email)
      } else if (appleQuery.id_token) {
        const token = appleQuery.id_token
        const decode = this.parseJwt(token)
        if (decode.email) {
          this.appleLoginDone(decode.email)
        }
      }
    }
  },
  mounted() {
    AppleID.auth.init({
      clientId: 'com.msc.sum.web',
      scope: 'email name',
      redirectURI: process.env.VUE_APP_APPLE_REDIRECT_URL,
      state: Math.random().toString(36).substr(2, 11),
      usePopup: false
    })
  },
  beforeDestroy() {
    document.removeEventListener(
      'AppleIDSignInOnSuccess',
      this.onAppleSignInSuccess
    )
    document.removeEventListener(
      'AppleIDSignInOnFailure',
      this.onAppleSignInFailure
    )
  },
  methods: {
    parseJwt(token) {
      var base64Url = token.split('.')[1]
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          })
          .join('')
      )

      return JSON.parse(jsonPayload)
    },
    showInfoMessage(message, isError) {
      this.isLoading = false

      this.showMessage = true
      this.messageText = message
      this.messageIsErr = isError || false

      setTimeout(() => {
        this.showMessage = false
        this.messageText = ''
        this.messageIsErr = false
      }, 2000)
    },
    onResetPWClick() {
      this.goPage('resetpassword')
    },
    // Apple
    async performAppleLogin() {
      this.isLoading = true

      try {
        await AppleID.auth.signIn()
      } catch (error) {
        this.isLoading = false
      }
    },
    appleLoginDone(email) {
      const userID = email
      this.$store
        .dispatch('auth/socialLogin', { userID, type: 'apple' })
        .then((data) => {
          const loggedIn = this.$store.state.auth.status.loggedIn
          if (loggedIn) {
            if (data.completeYN === 'Y') {
              this.moveToDashboard()
            } else {
              this.moveToGuidePage()
            }
          }
        })
        .catch((error) => {
          this.isLoading = false

          const resultData = error.resultData
          if (resultData.includes('UsernameNotFoundException')) {
            this.goPageWithParams('TermsConditions', {
              userID,
              socialType: 'Apple'
            })
          }
        })
    },
    // Facebook
    facebookCheckLoginStatus() {
      FB.getLoginStatus((response) => {
        this.facebookStatusChangeCallback(response)
      })
    },
    facebookStatusChangeCallback(response) {
      if (response.status === 'unknown') {
        this.performFacebookLogin()
      } else if (response.status === 'connected') {
        this.facebookGetUserInfo()
      }
    },
    performFacebookLogin() {
      FB.login(
        (response) => {
          if (response.status === 'connected') {
            this.facebookGetUserInfo()
          }
        },
        { scope: 'public_profile,email' }
      )
    },
    facebookGetUserInfo() {
      this.isLoading = true

      FB.api('/me', { fields: 'email' }, (response) => {
        const userID = response.email
        this.$store
          .dispatch('auth/socialLogin', { userID, type: 'facebook' })
          .then((data) => {
            const loggedIn = this.$store.state.auth.status.loggedIn
            if (loggedIn) {
              if (data.completeYN === 'Y') {
                this.moveToDashboard()
              } else {
                this.moveToGuidePage()
              }
            }
          })
          .catch((error) => {
            this.isLoading = false

            const resultData = error.resultData
            if (resultData.includes('UsernameNotFoundException')) {
              this.goPageWithParams('TermsConditions', {
                userID,
                socialType: 'Facebook'
              })
            }
          })
      })
    },
    // Google
    performGoogleLogin() {
      this.googleLogin = true

      this.auth2.signIn()
    },
    googleCheckLoginStatus() {
      if (this.auth2) {
        const googleUser = this.auth2.currentUser.get()
        const profile = googleUser.getBasicProfile()

        const userID = profile.getEmail()
        this.$store
          .dispatch('auth/socialLogin', { userID, type: 'google' })
          .then((data) => {
            const loggedIn = this.$store.state.auth.status.loggedIn
            if (loggedIn) {
              if (data.completeYN === 'Y') {
                this.moveToDashboard()
              } else {
                this.moveToGuidePage()
              }
            }
          })
          .catch((error) => {
            this.isLoading = false

            const resultData = error.resultData
            if (resultData.includes('UsernameNotFoundException')) {
              this.goPageWithParams('TermsConditions', {
                userID,
                socialType: 'Google'
              })
            }
          })
      }
    },
    onSignInClick() {
      var errorFlag = false

      if (!this.userID) {
        this.idMessage = 'Please check this area.'
        this.idHasError = true
        errorFlag = true
      } else {
        this.idMessage = 'Email'
        this.idHasError = false
      }
      if (!this.userPW) {
        this.pwMessage = 'Please check this area.'
        this.pwHasError = true
        errorFlag = true
      } else {
        this.pwMessage = 'Password'
        this.pwHasError = false
      }

      if (errorFlag) return
      this.isLoading = true

      const user = {
        id: this.userID,
        password: this.userPW
      }
      this.$store.dispatch('auth/login', user).then(
        (data) => {
          this.isLoading = false

          const loggedIn = this.$store.state.auth.status.loggedIn
          if (loggedIn) {
            if (data.completeYN === 'Y') {
              this.moveToDashboard()
            } else {
              this.moveToGuidePage()
            }
          }
        },
        (error) => {
          this.isLoading = false

          this.pwHasError = true
          this.pwMessage = error.error_description || error.error
        }
      )
    },
    onSignUpClick() {
      this.goPage('signup')
    },
    moveToDashboard() {
      this.goReplace('dashboard')
    },
    moveToGuidePage() {
      this.goReplace('signedup')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/acc.scss" scoped></style>
